import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode } from 'react';
import cls from './Text.module.scss';

export enum TextSize {
    text_16_300 = 'text_16_300',
    text_12 = 'text_12',
    text_14 = 'text_14',
    text_16 = 'text_16',
    text_18 = 'text_18',
    text_20 = 'text_20',
    text_24 = 'text_24',
    text_30 = 'text_30',
    text_36 = 'text_36',
    text_16_600 = 'text_16_600',
    text_18_600 = 'text_18_600',
    text_20_600 = 'text_20_600',
    text_24_600 = 'text_24_600',
    text_26_600 = 'text_26_600',
    text_28_600 = 'text_28_600',
    text_20_700 = 'text_20_700',
    text_32_600 = 'text_32_600'
}

interface TextProps {
    className?: string
    children: ReactNode
    positionCenter?: boolean
    size: TextSize
    color: string
}

export const Text = ({
    className, children, positionCenter, size, color,
}: TextProps) => (
    <p className={classNames(cls.Text, { [cls.positionCenter]: positionCenter }, [className, cls[size]])} style={{ color }}>
        {children}
    </p>
);
